export const isInlineCorrect = (question = {}, userAnswers = '', index) => {
  const { answers = [] } = question;

  if (!userAnswers) {
    return false;
  }

  return answers[index].includes(userAnswers);
};
